import script from "./ActionProduct.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActionProduct.vue?vue&type=script&setup=true&lang=ts"

import "./ActionProduct.vue?vue&type=style&index=0&id=d0414180&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0414180"]])

export default __exports__